import { ChartBarIcon } from '@heroicons/react/24/outline';

type Props = {};
export default function Report(_props: Props) {
  return (
    <div className='flex justify-center h-screen'>
      <div className='text-center p-6 rounded-lg'>
        <ChartBarIcon className='h-16 w-16 text-indigo-600 mx-auto mb-4' />
        <h1 className='text-3xl font-semibold text-gray-800 mb-2'>Sales and Marketting</h1>
        <p className='text-gray-600'>
          We're putting the final touches on our new reporting tools. You'll soon be able to generate detailed insights and analytics right
          here.
        </p>
      </div>
    </div>
  );
}
